import React, { useMemo } from "react";
import SegmentedToggle from "../../../Components/SegmentedToggle";
import { shouldShowCellChemistryFilter } from "../SOHAndRUL/utils/cellChemistryFilter";

// SegmentedToggle needs a non-null value per option; "All" stands for "no chemistry".
const ALL = "All";

/**
 * "All | LFP | NMC ..." chemistry toggle for the SOH / RUL card headers.
 *
 * value    - selected chemistry, or null for All
 * options  - chemistry names (from useCellChemistryOptions)
 * onChange - called with the chemistry name, or null for All
 * testIdPrefix - distinguishes the SOH and RUL instances
 */
const CellChemistryQuickFilter = ({ value = null, options = [], onChange, testIdPrefix = "cell-chemistry" }) => {
  const items = useMemo(() => [ALL, ...options], [options]);
  if (!shouldShowCellChemistryFilter(options)) return null;

  return (
    <SegmentedToggle
      label="Cell Chemistry"
      options={items}
      value={value ?? ALL}
      onChange={(next) => onChange?.(next === ALL ? null : next)}
      testIdPrefix={`${testIdPrefix}-filter`}
    />
  );
};

export default CellChemistryQuickFilter;
